import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom'
import HomePage from './pages/Home'
import MessageSenderPage from './pages/MessageSender'
import MessageSchedulerPage from './pages/MessageScheduler'
import ScheduledMessagesPage from './pages/ScheduledMessages'
import SettingsPage from './pages/Settings'
import SigninPage from './pages/Signin'
import ReportsPage from './pages/Reports'
import DocumentationPage from './pages/Documentation'
import ChangelogPage from './pages/Changelog'
import PaymentProfilesPage from './pages/PaymentProfiles'
import SmartFilterPage from './pages/SmartFilter'
import ErrorPage from './pages/Error'
import PilotoAutomaticoPage from './pages/PilotoAutomatico'

const router = createBrowserRouter([
  {
    // Rota sem caminho: existe só para pendurar o errorElement uma única vez
    // sobre todas as telas — inclusive sobre um endereço que não casa com
    // nenhuma. Sem ela, qualquer erro de render caía no boundary padrão do
    // React Router, que joga um stack trace em inglês na cara do cliente.
    element: <Outlet />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <HomePage />
      },
      {
        path: '/messages/send',
        element: <MessageSenderPage />
      },
      {
        path: '/messages/scheduler',
        element: <MessageSchedulerPage />
      },
      {
        path: '/messages/scheduled',
        element: <ScheduledMessagesPage />
      },
      {
        path: '/reports',
        element: <ReportsPage />
      },
      {
        path: '/settings',
        element: <SettingsPage />
      },
      {
        path: '/documentation',
        element: <DocumentationPage />
      },
      {
        path: '/signin',
        element: <SigninPage />
      },
      {
        path: '/changelog',
        element: <ChangelogPage />
      },
      {
        path: '/hiperpay/profiles',
        element: <PaymentProfilesPage />
      },
      {
        path: '/hipersync',
        element: <PilotoAutomaticoPage />
      },
      {
        path: '/smart-filter',
        element: <SmartFilterPage />
      }
    ]
  }
])

export default function Routes() {
  return <RouterProvider router={router} />
}
